/*
  破折转成驼峰
*/
export const toCamelCase = str =>
  str.replace(/-([^\s])/g, (_, $1) => $1.toUpperCase());

/**
 * 校验手机号码
**/
export const checkPhone = phone => {
  return (/^[1]([3-9])[0-9]{9}$/.test(phone))
}
